import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TripProviderSort,
  TripProviderVersionMap
} from '../../lib/types/models/trip-provider/trip-provider'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripProviders<
  T extends PaginationRequest<null, string, Version, TripProviderSort> | undefined
>(input: T = {} as T) {
  type V = T extends { version: infer U extends Version } ? U : 'FULL'

  if (!input?.sort) {
    input = { ...input, sort: { companyName: 'asc' } } as T
  }

  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.tripProviders.getAll.url, null), input))
    .get<PaginationResponse<TripProviderVersionMap[V]>>()
}
